<template>
  <div id="mapid" v-observe-visibility="visibilityChanged"></div>
</template>

<script>
import UtilitiesService from '../../services/UtilitiesService'

var leafletMap = null
var pruneCluster = null
var clusterSize
let railObjectByMarkerHashCode = {}

export default {
  name: 'dashboardMap',
  props: ['railObjects', 'lastUpdated'],
  data () {
    return {
    }
  },
  beforeCreate: function () {
  },
  created: function () {
  },
  mounted: function () {
    // var mayDecluster = true// scope.$eval(attrs.maydecluster)
    var clustering = true
    if (clustering === false) {
      clusterSize = -1
    }

    var mapElement = document.getElementById('mapid') // $(element).find('#mapid')[0]
    var accesstoken = 'pk.eyJ1Ijoia2FyaW5sb29zIiwiYSI6ImNqO' +
      'GVhczRnNDBuMjkzM3FseXdybjd0Y2EifQ.NHM9Pss5TvDSIQZXIWktCA'

    var colors = ['#4CAF50', '#FF9800', '#F44336', '#2196F3']
    var pi2 = Math.PI * 2

    var latlng = L.latLng(52.09083, 5.12222)
    // var latlng = L.latlng($rootScope.currentUser.DefaultLatitude,
    // $rootScope.currentUser.DefaultLongtitude )
    // var tiles = L.tileLayer(
    //   'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
    //     maxZoom: 17,
    //     attribution: 'Strukton',
    //     maxNativeZoom: 19,
    //     id: 'mapbox.streets',
    //     accessToken: accesstoken
    //   })
    var tiles = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Strukton',
      minZoom: 2,
      maxZoom: 17,
      id: 'mapbox/streets-v11',
      accessToken: accesstoken
    })
    leafletMap = L.map(mapElement, {
      center: latlng, zoom: 7, layers: [tiles], maxBounds: [[-90, -180], [90, 180]]
    })

    pruneCluster = new PruneClusterForLeaflet(120)
    var toggle = L.easyButton({
      states: [{
        stateName: 'add-markers',
        icon: '<i class="material-icons md-18">place</i>',
        title: 'markers',
        onClick: function (control) {
          clustering = false
          pruneCluster.Cluster.Size = -1
          pruneCluster.ProcessView()
          control.state('remove-markers')
        }
      },
      {
        icon: '<i class="material-icons md-18">refresh</i>',
        stateName: 'remove-markers',
        onClick: function (control) {
          clustering = true
          pruneCluster.Cluster.Size = 120 // default
          pruneCluster.ProcessView()
          control.state('add-markers')
        },
        title: 'cluster'
      }]
    })
    toggle.addTo(leafletMap)
    /* if (mayDecluster) {
      toggle.addTo(leafletMap)
    } */

    /* istanbul ignore next: prune cluster stuff */
    pruneCluster.BuildLeafletClusterIcon = function (cluster) {
      var e = new L.Icon.MarkerCluster()
      e.stats = cluster.stats
      e.population = cluster.population
      return e
    }

    /* istanbul ignore next: TODO: rewrite code */
    pruneCluster.PrepareLeafletMarker = (leafletMarker, data) => {
      var railObject = railObjectByMarkerHashCode[data.markerHashCode]

      var statusdescription = ''
      if (railObject.OperationModeId === 5) {
        statusdescription = 'maintenance' // $filter('translate')('maintenance')
      } else {
        switch (railObject.MonitorStatusId) {
          case 0:
            statusdescription = 'unknown' // $filter('translate')('unknown')
            break
          case 1:
            statusdescription = 'normal' // $filter('translate')('normal')
            break
          case 2:
            statusdescription = 'warn' // $filter('translate')('warn')
            break
          case 3:
            statusdescription = 'error' // $filter('translate')('error')
            break
          default:
            statusdescription = 'unknown' // $filter('translate')('unknown')
            break
        }
      }

      let assetPath = ''
      switch (railObject.DataSourceCode) {
        case 'WID':
          assetPath = 'switch'
          break
        case 'ATD':
          assetPath = 'axlecounter'
          break
        case 'AKD':
          assetPath = 'axleshunt'
          break
        case 'CDD':
          assetPath = 'mixedsignals'
          break
        default:
          assetPath = 'switch'
      }

      var statusclass = UtilitiesService.railObjectClass(railObject)
      data.popupContent = '<div class="infoDiv">' +
        '<h2 class="status-' + statusclass + '"><strong><a href="#/' + assetPath + '/' + railObject.RailObjectId + '">' + railObject.Name + '</a></strong></h2>' +
        '<strong>' + railObject.ComplexName + '</strong>' +
        '<p> Status : <span class="status-' + statusclass + '"><strong>' + statusdescription + '</strong></span></p>' +
        '<p> Complex: ' + railObject.ComplexName + '<p>' +
        '<p> Type   : ' + railObject.ObjectCodeDescription + '</p>' +
        // '<p> <a href='' + self.Url + ''>Details</a>' +
        '</div> '

      railObject.leafletMarker = leafletMarker
      this.setIcon(railObject)
      if (leafletMarker.getPopup()) {
        leafletMarker.setPopupContent(data.popupContent)
      } else {
        leafletMarker.bindPopup(data.popupContent)
      }
    }

    /* istanbul ignore next: prune cluster stuff */
    L.Icon.MarkerCluster = L.Icon.extend({
      options: {
        iconSize: new L.Point(44, 44),
        className: 'prunecluster leaflet-markercluster-icon'
      },
      createIcon: function () {
        // based on L.Icon.Canvas from shramov/leaflet-plugins (BSD licence)
        var e = document.createElement('canvas')
        this._setIconStyles(e, 'icon')
        var s = this.options.iconSize
        e.width = s.x
        e.height = s.y
        this.draw(e.getContext('2d'), s.x, s.y)
        return e
      },
      createShadow: function () {
        return null
      },
      draw: function (canvas, width, height) {
        var start = 0
        for (var i = 0, l = colors.length; i < l; ++i) {
          var size = this.stats[i] / this.population
          if (size > 0) {
            canvas.beginPath()
            canvas.moveTo(22, 22)
            canvas.fillStyle = colors[i]
            var from = start + 0.14
            var to = start + size * pi2
            if (to < from) {
              from = start
            }
            canvas.arc(22, 22, 22, from, to)
            start = start + size * pi2
            canvas.lineTo(22, 22)
            canvas.fill()
            canvas.closePath()
          }
        }
        canvas.beginPath()
        canvas.fillStyle = 'white'
        canvas.arc(22, 22, 18, 0, Math.PI * 2)
        canvas.fill()
        canvas.closePath()
        canvas.fillStyle = '#555'
        canvas.textAlign = 'center'
        canvas.textBaseline = 'middle'
        canvas.font = 'bold 12px sans-serif'
        canvas.fillText(this.population, 22, 22, 40)
      }
    })
    leafletMap.addLayer(pruneCluster)
    this.setRailObjects()
  },
  beforeDestroy: function () {
  },
  methods: {
    visibilityChanged: function () {
      if (leafletMap !== null) {
        leafletMap.invalidateSize()
      }
    },
    setRailObjects: function () {
      pruneCluster.RemoveMarkers()
      pruneCluster.ProcessView()

      var latLngs = []
      // add all markers, except the ones with MonitorStatus == 'None'
      this.railObjects
        .filter(item => { return item.MonitorStatusId !== 0 })
        .forEach((railObject) => {
          this.addMarker(railObject)
          this.setIcon(railObject)
          latLngs.push(L.latLng(railObject.marker.position.lat, railObject.marker.position.lng))
        })

      var bounds = L.latLngBounds(latLngs)
      leafletMap.fitBounds(bounds)

      if (clusterSize) {
        pruneCluster.Cluster.Size = clusterSize
      }
      pruneCluster.ProcessView()

      leafletMap.invalidateSize()
    },
    addMarker: function (railObject) {
      var marker = new PruneCluster.Marker(railObject.Latitude, railObject.Longtitude, {})
      marker.data.markerHashCode = marker.hashCode
      railObjectByMarkerHashCode[marker.hashCode] = railObject
      if (railObject.OperationModeId === 1) {
        switch (railObject.MonitorStatusId) {
          case 1:
            marker.category = 0 // green
            break
          case 2:
            marker.category = 1 // orange
            break
          case 3:
            marker.category = 2 // red
            break
          default:
            marker.category = 3 // blue
            break
        }
      } else {
        marker.category = 3 // blue
      }

      railObject.marker = marker
      pruneCluster.RegisterMarker(marker)
    },
    setIcon: function (railObject) {
      if (!railObject.leafletMarker) {
        return
      }

      var leafletMarker = railObject.leafletMarker

      var iconUrl
      if (railObject.OperationModeId === 1) {
        switch (railObject.MonitorStatusId) {
          case 1:
            iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers' +
              '/master/img/marker-icon-2x-green.png'
            break
          case 2:
            iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers' +
              '/master/img/marker-icon-2x-orange.png'
            break
          case 3:
            iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers' +
              '/master/img/marker-icon-2x-red.png'
            break
          default:
            iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers' +
              '/master/img/marker-icon-2x-black.png'
            break
        }
      } else {
        iconUrl = 'https://cdn.rawgit.com/pointhi/leaflet-color-markers' +
          '/master/img/marker-icon-2x-blue.png'
      }

      leafletMarker.setIcon(L.icon({
        iconUrl: iconUrl,
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }))
    }
  },
  watch: {
    lastUpdated: function () {
      this.setRailObjects()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mapid {
  top: 3px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/DashboardMap.vue